import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static values = { presenceableType: String, presenceableId: String }

  connect() {
    this.consumer = createConsumer()
    this.channel = this.consumer.subscriptions.create(
      { channel: "PresenceChannel", presenceable_type: this.presenceableTypeValue, presenceable_id: this.presenceableIdValue },
      {
        received(data) {
          // Turbo Streams handle DOM updates automatically
        },
        connected: () => {
          this.startHeartbeat()
        },
        disconnected: () => {
          this.stopHeartbeat()
        }
      }
    )
  }

  disconnect() {
    this.stopHeartbeat()
    if (this.channel) {
      this.channel.unsubscribe()
    }
    if (this.consumer) {
      this.consumer.disconnect()
    }
  }

  startHeartbeat() {
    this.stopHeartbeat()
    this.heartbeatInterval = setInterval(() => {
      if (this.channel) {
        this.channel.perform("heartbeat")
      }
    }, 30000)
  }

  stopHeartbeat() {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval)
      this.heartbeatInterval = null
    }
  }
}
